// extracted by mini-css-extract-plugin
export var chevron = "_ir-2";
export var dropdownItems = "_ir-0";
export var item = "_ir-1";